import classnames from 'classnames';
import React from 'react';
import { IoMdSave as DiskIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  loadingIndicator: {
    color: '#FF3C44',
    composes: ['mb6'],
  },
});

const LoaderIndicatorComponent = React.memo(() => {
  const classes = useStyles();
  return (
    <div className={classnames(classes.loadingIndicator)}>
      <DiskIcon className="blink" size={24} />
    </div>
  );
});

LoaderIndicatorComponent.displayName = 'LoaderIndicatorComponent';

export default LoaderIndicatorComponent;
